<template>
  <v-dialog
    v-model="isDialogVisible"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    :z-index="1000"
  >
    <v-card>
      <full-view
        ref="fullView"
        @askToClose="isDialogVisible = false"
      />
    </v-card>
  </v-dialog>
</template>
<script>
import { ref } from '@vue/composition-api'
import FullView from './FullView.vue'

export default {
  components: { FullView },
  setup() {
    const isDialogVisible = ref(false)
    const fullView = ref()

    const ShowDialog = key => {
      isDialogVisible.value = true
      if (!fullView.value) {
        setTimeout(() => { fullView.value.GetBooking(key) }, 500)
      } else {
        fullView.value.GetBooking(key)
      }
    }

    return {
      isDialogVisible,
      fullView,
      ShowDialog,
    }
  },
}
</script>
